import type { CandidateResumeSummary } from '@entities/candidates';

export const formatCandidateResumeSalary = (record: CandidateResumeSummary) => {
  if (record.salary === null) {
    return '-';
  }

  return [record.salary, record.currency?.value].filter(Boolean).join(' ');
};

export const formatCandidateResumeReferences = (
  references: CandidateResumeSummary['employmentTypes']
) =>
  references
    .map(reference => reference.name.trim())
    .filter(Boolean)
    .join(', ') || '-';

export const formatCandidateResumeValue = (value: string) =>
  value.trim() || '-';
